module.exports = __webpack_public_path__ + "img/IMS_logo_200007_4c.ea28a7c3.gif";